import $ from 'jquery';
import debounce from 'just-debounce';
import CurrencyConverter from 'shopify-currency-converter';
import Menu from '../Menu';
import Quantity from '../snippets/Quantity';

export default class StaticCart {
  constructor(section) {
    this.$el = $(section.el);
    this.data = section.data;
    this.$cartItemButtonDismiss = $('[data-cart-item-button-dismiss]', this.$el);
    this.postMessage = section.postMessage;

    // Initialize cart items
    this.items = [];

    this.$el.find('[data-quantity]').each((index, el) => {
      const $el = $(el).closest('[data-cart-item]');
      const variantID = $el.data('cart-item-variant-id');
      const quantity = new Quantity(el);

      $(quantity.input).on('change.cart', debounce(event => {
        this._changeQuantity(variantID, quantity.value);
      }, 500));

      this.items.push({ $el, quantity, variantID });
    });

    this._bindEvents();

    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.data.button_update_shipping_title,
      submitButtonDisabled: this.data.button_update_shipping_disabled_title,
      customerIsLoggedIn: this.data.customer_logged_in,
      moneyFormat: this.data.money_format,
    });

    // Menu system
    this.states = {
      default: {
        buttonsSelector: '[data-cart-menu-buttons-default]',
        buttons: [
          {
            selector: '[data-cart-menu-button-calculate-shipping]',
            callback: () => { this.menu.changeState(this.states.shippingCalculator); },
          },
        ],
      },
      shippingCalculator: {
        slideoutSelector: '[data-cart-menu-slideout]',
        buttonsSelector: '[data-cart-menu-buttons-shipping-calculator]',
        buttons: [
          {
            selector: '[data-cart-menu-slideout-button-dismiss]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-cart-menu-button-cancel-shipping]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-cart-menu-button-update-shipping]',
            // None needed, Shopify.Cart.ShippingCalculator takes care of this
            callback: () => {},
          },
        ],
        dismiss: () => { this.menu.changeState(this.states.default); },
      },
    };

    this.$cartMenuContainer = $('[data-cart-menu-container]', this.$el);
    this.menu = new Menu(this.$cartMenuContainer, this.states, this.states.default);
  }

  _bindEvents() {
    this.$cartItemButtonDismiss.on('click.cart', (event) => {
      const $cartItem = $(event.currentTarget).closest('[data-cart-item]');
      const variantID = $cartItem.data('cart-item-variant-id');

      this._removeFromCart($cartItem, variantID);
    });
  }

  _unbindEvents() {
    this.$cartItemButtonDismiss.off('click.cart');
  }

  _removeFromCart($cartItem, variantID) {
    this._updateCart(variantID, 0)
      .done((response) => {

        if (response.item_count == 0) {
          this.$cartMenuContainer.slideUp();
          $('[data-cart-form]').slideUp(() => {
            $('[data-cart-empty-message]', this.$el).show();
          });
        } else {
          $cartItem.slideUp(() => {
            $cartItem.remove();
          });
        }

        this.postMessage('product:add-to-cart', { response });

        $('[data-cart-subtotal]', this.$el)
          .text(Shopify.formatMoney(response.original_total_price, this.data.money_format))
          .each((index, el) => CurrencyConverter.update(el));
      });
  }

  _changeQuantity(variantID, quantity) {
    this._updateCart(variantID, quantity)
      .done((response) => {
        // Update item counts
        if (response && response.items) {
          response.items.forEach(responseItem => {
            this.items.forEach(item => {
              if (item.variantID === responseItem.variant_id) {
                item.quantity.change(responseItem.quantity, false);
              }
            });
          });
        }

        this.postMessage('product:add-to-cart', { response });

        // Update price
        $('[data-cart-subtotal]', this.$el)
          .text(Shopify.formatMoney(response.original_total_price, this.data.money_format))
          .each((index, el) => CurrencyConverter.update(el));
      });
  }

  _updateCart(variantID, quantity) {
    let updateJson = {
      id: variantID,
      quantity: quantity,
    };

    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: updateJson,
      dataType: 'json',
    });
  }

  _toggleSlideout() {
    this.$slideout.slideToggle();
  }

  onSectionUnload() {
    this._unbindEvents();

    // Unload cart items
    this.items.forEach(item => {
      item.quantity.unload();
    });
  }
}
